export default __webpack_public_path__ + "static/media/icon-shape.ba104c10.png";